export default "__VITE_ASSET__DPo3PUbn__"